import React from 'react';
import ReactDOM from "react-dom/client";
import { Provider } from 'react-redux';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Loader } from 'semantic-ui-react';
import { ConfigProvider } from 'antd';
import 'semantic-ui-css/semantic.min.css';

import { store, persistor } from './configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { token, components } from './config-antd/config'

import Home from './views/Home';
import Products from './views/Products';
import Categories from './views/Categories';
import Product from './views/Product';
import Cart from './views/Cart';
import Search from './views/Search';
import CheckoutStepShipping from './views/Checkout_1_StepShipping';
import CheckoutStepPayment from './views/Checkout_2_StepPayment';

import './index.css';
import AccessChecker from "./views/AccessChecker";
import CheckoutStepConfirm from "./views/Checkout_3_StepConfirm";
import Orders from "./views/Orders";
import Order from "./views/Order";
import Events from "./views/Events";
import Counterparties from "./views/Counterparties";
import CounterForm from "./views/CounterForm/CounterForm";
import Organizer from "./views/Organizer";

const root = ReactDOM.createRoot(document.getElementById("root"));

console.log(`App "${process.env.REACT_APP_NAME}" version ${process.env.REACT_APP_VERSION} API Backend ${process.env.REACT_APP_API_URL} is running in ${process.env.REACT_APP_ENV} mode`)

root.render(
  <Provider store={store}>
    <ConfigProvider theme={{token, components}}>
      <PersistGate loading={<Loader active />} persistor={persistor}>
        <HashRouter>
          <App>
            <Routes>
              <Route exact path="/" Component={props => <Home {... props}/>} />
              <Route path="/check-access" Component={props => <AccessChecker {... props}/>} />
              <Route path="/search/:search" Component={props => <Search {... props}/>} />
              <Route path="/checkout-step-shipping" Component={props => <CheckoutStepShipping {... props}/>} />
              <Route path="/checkout-step-payment" Component={props => <CheckoutStepPayment {... props}/>} />
              <Route path="/checkout-step-confirm" Component={props => <CheckoutStepConfirm {... props}/>} />
              <Route path="/orders" Component={props => <Orders {... props}/>} />
              <Route path="/orders/:orderId" Component={props => <Order {... props}/>} />
              <Route path="/events" Component={props => <Events {... props}/>} />
              <Route path="/counterparties" Component={props => <Counterparties {... props}/>} />
              <Route path="/counterparties-form" Component={props => <CounterForm {... props}/>} />
              <Route path="/counterparty/:counterId" Component={props => <CounterForm {... props}/>} />
              <Route path="/organizer" Component={props => <Organizer {... props}/>} />
            </Routes>
          </App>
        </HashRouter>
      </PersistGate>
    </ConfigProvider>
  </Provider>
);

registerServiceWorker();
